import React from 'react';
import '@/components/primitives/primitives.css';

/**
 * The one page-title style for every app page: title (22px semibold), an
 * optional one-line description, optional meta next to the title, and actions
 * on the right. Where you are is said once, by the breadcrumb in the top bar,
 * so there is no eyebrow label and no icon tile here.
 *
 *   <PageHeader
 *     title="Vulnerabilities"
 *     subtitle="Every CVE named in your briefs, with CISA exploitation status."
 *     meta={<Badge>83 CVEs</Badge>}
 *     actions={<Button>Export</Button>}
 *   />
 *
 * `icon`, `eyebrow` and `breadcrumbs` are accepted for older callers and ignored.
 */
export default function PageHeader({ title, subtitle, actions, meta, className = '', icon, eyebrow, breadcrumbs }) {
  return (
    <header className={`is-page-header ${className}`}>
      <div className="is-page-header-row">
        <div className="min-w-0">
          <div className="is-page-header-title">
            <h1 className="t-title">{title}</h1>
            {meta}
          </div>
          {subtitle && <p className="is-page-header-sub">{subtitle}</p>}
        </div>
        {actions && <div className="is-page-header-actions">{actions}</div>}
      </div>
    </header>
  );
}
